module.exports = __webpack_public_path__ + "img/fankui_banner_tr.576066fa.jpg";